import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { MemberSourceDto } from './dto/member-source.dto';

@Injectable({
  providedIn: 'root',
})
export class MemberSourceService {
  constructor(private _apiService: ApiService) {}

  getPaged(searchDto: PagedSearch, forceRefresh?: boolean): Promise<PagedResultGeneric<MemberSourceDto>> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged('MemberSources', searchDto, cacheOptions, true);
  }

  get(memberSource: string): Promise<MemberSourceDto> {
    return this._apiService.get(`MemberSource/${memberSource}`, null, true);
  }

  create(memberSource: MemberSourceDto): Promise<string> {
    return this._apiService.post('MemberSources', memberSource, true);
  }

  update(originalMemberSource: string, memberSource: MemberSourceDto): Promise<void> {
    return this._apiService.put(`MemberSource/${originalMemberSource}`, memberSource, true);
  }

  delete(memberSource: string): Promise<void> {
    return this._apiService.delete(`MemberSource/${memberSource}`, true);
  }
}
